jQuery(document).on('click touchstart','button.preview-atc-btn',function(evt){
    evt.preventDefault();
    evt.stopPropagation();

    const $self = jQuery(this);
    const qty = $self.closest('form').find('.quantity__select [data-quantity-select]').val();
    const varID = $self.closest('[data-grid-inner]').find('[data-preview-var-id]').data('preview-var-id');
    const $statusAnnounceElem = $self.parent().find('.addedMessageBundleText');
    $statusAnnounceElem.text("Please wait, adding product to the cart");

    $self.addClass('click-processing').attr('disabled', true);

    // Do Not Remove Code - Add Properties for GWP Discount
    let properties = {};
    let bundleVarIdElement = $self.closest(".grid-item").find("[data-bundleVarId]");
    if (bundleVarIdElement.length > 0) {
        properties["_bundleVarId"] = bundleVarIdElement.val() || null;
    }
    // Do Not Remove Code - Add Properties for GWP Discount

    _theme.toggleLoading(1);
    _theme.Helpers.addProductToCart(varID,qty,properties, function(resp) {
        _theme.MiniCart.lineItemChangeCallBack(resp, function(){
            $statusAnnounceElem.text('Item added to your cart successfully');
            _theme.toggleLoading();
            _theme.toggleSideCart(1, $self, true);

            $self.closest('[data-grid-inner]').find('.preview-size-qv').removeClass('active');
            $self.closest('[data-grid-inner]').find('[data-grid-inner-top]').removeClass('hidden');
            $self.closest('[data-grid-inner]').find('[data-preview-size-grid]').addClass('hidden');

            $self.removeAttr('disabled');
            $self.removeClass('click-processing');
        });
    }, function(err){
        console.error(err)
    });
});